import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import AuditoriaClassificacaoNotaService from "service/auditoria5s/AuditoriaClassificacaoNotaService";
import AuditoriaClassificacaoNota from "model/auditoria5s/auditoria/AuditoriaClassificacaoNota";
import ImagemFixa from "model/ImagemFixa";
import { useToastContext } from "components/alert/ToastContext";


export default function AuditoriaClassificacaoNotaPage() {

    const service = new AuditoriaClassificacaoNotaService();

    const [dados, setDados] = useState<AuditoriaClassificacaoNota[]>([]);
    const [imagens, setImagens] = useState<ImagemFixa[]>([]);

    const { msgAlerta, msgErro, msgSucesso } = useToastContext();


    useEffect(() => {
        carregar();
    }, []);


    async function carregar() {

        const classificacoes = await service.buscar();
        const imagens = await service.buscarImagensDisponiveis();

        setDados(classificacoes);
        setImagens(imagens);
    }


    function alterarCampo(
        index: number,
        campo: keyof AuditoriaClassificacaoNota,
        valor: any
    ) {

        const copia = [...dados];

        copia[index] = {
            ...copia[index],
            [campo]: valor
        };
        setDados(copia);
    }


    function alterarImagem(
        index: number,
        imagem: ImagemFixa
    ) {

        const copia = [...dados];
        copia[index].imagemFixa = imagem;
        setDados(copia);
    }

    function validar() {

        const ordenado = [...dados]
            .sort((a, b) => a.notaMinima - b.notaMinima);


        for (let i = 0; i < ordenado.length; i++) {

            const atual = ordenado[i];

            if (atual.notaMinima > atual.notaMaxima) {
                msgAlerta("Alerta", `Nota mínima maior que nota máxima: ${atual.descricao}`);
                return false;
            }

            if (i > 0) {

                const anterior = ordenado[i - 1];

                if (atual.notaMinima <= anterior.notaMaxima) {
                    msgAlerta("Alerta", `Conflito entre ${anterior.descricao} e ${atual.descricao}`);
                    return false;
                }
            }
        }


        return true;
    }


    async function salvar() {
        if (!validar())
            return;
        service.alterar(dados).then(() => {

            msgSucesso("Sucesso", "Alterado com sucesso");
        }).catch((err) => {
            msgErro("Erro", "Falha ao alterar");
        });
    }

    return (
        <div style={{ padding: "20px" }}>
            <h2>Classificação das notas da auditoria</h2>

            {dados.map((item, index) => (
                <Card
                    key={index}
                    style={{ marginBottom: "15px" }}
                >
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(12, 1fr)",
                        gap: "15px"
                    }}>
                        <div style={{ gridColumn: "span 4" }}>
                            <label>Descrição</label>

                            <InputText
                                style={{ width: "100%" }}
                                value={item.descricao}
                                onChange={(e) =>
                                    alterarCampo(
                                        index,
                                        "descricao",
                                        e.target.value
                                    )
                                }
                            />
                        </div>

                        <div style={{ gridColumn: "span 2" }}>
                            <label>Nota mínima</label>

                            <InputNumber
                                style={{ width: "100%" }}
                                value={item.notaMinima}
                                min={0}
                                max={10}
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                onValueChange={(e) =>
                                    alterarCampo(
                                        index,
                                        "notaMinima",
                                        e.value
                                    )
                                }
                            />
                        </div>

                        <div style={{ gridColumn: "span 2" }}>
                            <label>Nota máxima</label>

                            <InputNumber
                                style={{ width: "100%" }}
                                value={item.notaMaxima}
                                min={0}
                                max={10}
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                onValueChange={(e) =>
                                    alterarCampo(
                                        index,
                                        "notaMaxima",
                                        e.value
                                    )
                                }
                            />
                        </div>

                        <div style={{ gridColumn: "span 4" }}>
                            <label>Imagem</label>

                            <Dropdown
                                style={{ width: "100%" }}
                                value={item.imagemFixa}
                                options={imagens}
                                optionLabel="nome"
                                placeholder="Selecione"
                                onChange={(e) =>
                                    alterarImagem(
                                        index,
                                        e.value
                                    )
                                }
                            />
                        </div>

                        {item.imagemFixa && (
                            <div style={{ gridColumn: "span 12" }}>
                                <img
                                    src={`data:image/png;base64,${item.imagemFixa.base64}`}
                                    style={{
                                        maxHeight: "100px"
                                    }}
                                    alt=""
                                />
                            </div>
                        )}
                    </div>
                </Card>
            ))}

            <Button
                label="Salvar"
                icon="pi pi-save"
                onClick={salvar}
            />
        </div>
    );
}